import { render, staticRenderFns } from "./ScreenLayout.vue?vue&type=template&id=16564a71&scoped=true"
import script from "./ScreenLayout.vue?vue&type=script&lang=js"
export * from "./ScreenLayout.vue?vue&type=script&lang=js"
import style0 from "./ScreenLayout.vue?vue&type=style&index=0&id=16564a71&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16564a71",
  null
  
)

export default component.exports